import { Form, Row, Col } from "antd";
import ControlledTextArea from "../../components/ControlledTextArea";
import ControlledSelect from "../../components/Backoffice/ControlledSelectV1";
import { REJECTION_REASONS } from "../../utils/constantData";

const MarkAsRegretOrderForm = ({ control, errors }) => {
  return (
    <Form colon={false}>
      <Row gutter={24}>
        <Col span={24}>
          <ControlledSelect
            required
            control={control}
            name="rejectionType"
            label="Rejection Type"
            options={REJECTION_REASONS}
            errors={errors}
          />
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={24}>
          <ControlledTextArea
            control={control}
            name="rejectionReason"
            label="Rejection Reason (Optional)"
            errors={errors}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default MarkAsRegretOrderForm;
